export const HEADER_TABLE_NAMES = ["Numer", "Data utworzenia", "Użytkownik"];
